module.exports = __webpack_public_path__ + "static/media/ScreenScrape.9b36f3d0.jpg";